import { EmployeeRolesEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsEnum } from "class-validator";

export class EmployeeRoleRequest{
    @ApiProperty({enum:EmployeeRolesEnum})
    @IsEnum(EmployeeRolesEnum)
    employeeRole:EmployeeRolesEnum;
    
    constructor(employeeRole:EmployeeRolesEnum){
        this.employeeRole = employeeRole;
    }
}